__webpack_require__.p = "https://ta-chat-assistant-fe.dev.securitize.io/";